import React, {useEffect} from "react";
import classes from "./Mayor1551.module.scss";
import Heading from "../../../components/caseStudy/heading/Heading.tsx";
import Info, {Feature, Topic} from "../../../components/caseStudy/info/Info.tsx";
import logo from "./media/logo.svg";
import OtherProjects from "../../../components/caseStudy/other-projects/OtherProjects.tsx";
import {ECaseStudy} from "../../../enums/case-study.enum.ts";
import OrganizationSeo from "../../../components/Seo/OrganizationSeo.tsx";
import { useTranslation } from "react-i18next";


const Mayor1551 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    const { t } = useTranslation();
    
    const title = [t('mayor1551.title'), t('mayor1551.blueTitle')]

    const description = [
        t('mayor1551.text')
    ]

    const infoTitle = t('mayor1551.info.title');

    const infoTitleMessage = t('mayor1551.info.text')
    const topics: Topic[] = t('mayor1551.topic', {returnObjects: true})

    const features: Feature = {
        list: t('mayor1551.featuresList', {returnObjects: true})
    }

    const rightBlock = {
    platforms: t('mayor1551.rightBlock.platforms', {returnObjects: true}),
    services: t('mayor1551.rightBlock.services', {returnObjects: true}),
    audience: t('mayor1551.rightBlock.audience', {returnObjects: true}),
    field: t('mayor1551.rightBlock.field', {returnObjects: true})
    }

    return (
        <>
            <OrganizationSeo
                title="Goteco: Secure and Scalable GovTech and Business Solutions"
                description="Goteco specializes in developing secure, scalable systems that boost efficiency across public and private sectors, optimizing processes in manufacturing, e-commerce, and construction industries."
                url="https://go-te.co/"
                image="https://go-te.co/logo.svg"
            />

            <section className={classes.section} id="nav-dark">
                <Heading
                    title={title}
                    description={description}
                    maxWidth={800}
                    imageName={'1551.webp'}
                    buttonText={t('mayor1551.buttonText')}
                    href={"https://1551.gov.ua"}
                />

                <Info
                    title={infoTitle}
                    titleMessage={infoTitleMessage}
                    topics={topics}
                    featuresText={t('mayor1551.featuresText')}
                    features={features}
                    rightBlock={rightBlock}
                />

                <div className={classes["image-section"]}>
                    <div className={classes["overlay"]}></div>
                    <div className={classes["image-container"]}>
                        <img className={classes.logo} src={logo} alt="1551 Kyiv Mayor’s Service logo"/>
                        <div className={classes.text}>
                            {t('mayor1551.bottomText')}
                        </div>
                    </div>
                </div>

                <OtherProjects name={ECaseStudy.MAYOR_1551}/>
            </section>
        </>
    );
};

export default Mayor1551;